<div *ngIf="checkoutProcessView">
    <fuse-card class="flex flex-col p-4">

        <div class="flex flex-row">

            <div class="flex flex-col w-full">

                <div class="flex flex-row">
                    <div class="flex w-10 h-10 justify-center items-center bg-primary-200 rounded-full mr-2 md:mr-8">
                        <mat-icon svgIcon="heroicons_solid:banknotes" [color]="'primary'"></mat-icon>
                    </div>
                    <div class="flex flex-row font-bold text-black text-2xl">
                        Debit order
                    </div>
                </div>

                <hr class="my-5">
            </div>
        </div>
        <div class="flex flex-row w-full font-extrabold text-black text-2xl pb-8">
            Debit order mandate required
        </div>
        <div class="flex flex-row w-full">
            <div class="flex flex-col text-black">
                To activate your service, an debit order needs to be signed.
                You can either sign your Debit Order now, or later, however <b>your service will not be activated until payment is made</b>
            </div>
        </div>
        <div class="flex flex-row pt-8 justify-center items-center md:justify-start">
            <button
                class="font-bold"
                mat-flat-button
                [color]="'accent'" 
                (click)="debitOrderMandateAction(debitOrderMandate)"
                >
                {{debitOrderMandate?.Status.toLowerCase() == "accepted" ? 'View accepted mandate' : 'Accept mandate'}}
            </button>
        </div>
    </fuse-card>
</div>

<div *ngIf="!checkoutProcessView && orderFromDashboard?.DebitOrderMandateRequired">
    <div>
        <section>
            <h1 class="font-bold text-md md:text-lg">
                Mandate Details
            </h1>
            <div *ngIf="orderFromDashboard?.debitOrderMandate?.Status.toLowerCase() == 'pending'">
                <button class="mt-4 text-md md:text-lg font-bold bg-accent self-start w-full lg:w-1/3" mat-flat-button (click)="debitOrderMandateAction(orderFromDashboard?.debitOrderMandate)">
                    Sign your debit order mandate
                 </button>
            </div>
            <div *ngIf="orderFromDashboard?.debitOrderMandate?.Status.toLowerCase() == 'accepted'">
                <button class="mt-4 text-md md:text-lg font-bold bg-accent self-start w-full lg:w-1/3" mat-flat-button (click)="debitOrderMandateAction(orderFromDashboard?.debitOrderMandate)">
                    View your debit order mandate
                 </button>
            </div>
            <div *ngIf="orderFromDashboard?.debitOrderMandate?.Status.toLowerCase() != 'accepted' && orderFromDashboard?.debitOrderMandate?.Status.toLowerCase() != 'pending'">
                <button class="mt-4 text-md md:text-lg font-bold bg-accent self-start w-full lg:w-1/3" mat-flat-button (click)="generateDebitOrderMandate(orderFromDashboard)">
                    Generate mandate
                 </button>
            </div>
        </section>
    </div>
</div>